/* CANFOTO · ETAP 2 · R14-COMM-D1
   LIVE CONTACT DOCK · production runtime
   Tidio owner: official tidioChatApi
   WhatsApp owner: existing CK:WhatsApp launcher/action, captured at runtime.
*/
(()=>{
'use strict';

const VERSION='CANFOTO-ETAP2-R14-COMM-D1.3-LIVE-CONTACT-DOCK-R3';
const SUPPORTED_THEMES=Object.freeze([
  'cf-editorial',
  'cf-magazine',
  'cf-nature',
  'cf-newsroom',
  'cf-retrofuture',
  'cf-redaxis',
  'cf-chrome',
  'cf-cinema',
  'cf-hyperpop'
]);

if(window.CANFOTO_LIVE_CONTACT_DOCK?.version===VERSION)return;

const root=document.querySelector('[data-cf-contact-dock]');
if(!root)return;

const tab=root.querySelector('#cfLiveContactTab');
const panel=root.querySelector('#cfLiveContactPanel');
const closeButtons=[...root.querySelectorAll('[data-cf-contact-close]')];
const tidioButton=root.querySelector('[data-cf-contact-tidio]');
const tidioStatus=root.querySelector('[data-cf-tidio-status]');
const tidioDescription=root.querySelector('[data-cf-tidio-description]');
const whatsappButton=root.querySelector('[data-cf-contact-whatsapp]');
const feedback=root.querySelector('[data-cf-contact-feedback]');

const state={
  status:'BOOTING',
  initialClosed:true,
  dockOpen:false,

  tidioReady:false,
  tidioListenersBound:false,
  tidioHideApplied:false,
  tidioStatus:null,
  tidioOpen:false,
  tidioPendingOpen:false,

  whatsapp:{
    captured:false,
    nativeHidden:false,
    actionMode:null,
    href:null,
    unsupportedIframeOnly:false,
    adapterMode:'CK_EXACT_DOM_V1',
    buttonSelector:'#chwhatsapp-btn',
    containerSelector:'#carthike-chat-button-container',
    wrapperSelector:'#carthike-chat-wrapper',
    observerMode:'ADDED_NODES_ONLY',
    observerCallbacks:0,
    captures:0,
    suppressions:0,
    pollingTimers:0,
    lastSeenAt:0
  },

  currentTheme:
    document.documentElement.getAttribute('data-cf-theme')||'',
  supportedThemeCount:SUPPORTED_THEMES.length,
  closedTabAccentPercent:77,
  closedTabTransparencyPercent:23,
  whatsappAlwaysOn:true,
  lastError:''
};

let tidioApi=null;
let whatsappAction=null;
let whatsappNativeWrapper=null;
let whatsappObserver=null;
let tidioPoll=null;
let tidioOpenFailTimer=null;

function snapshot(){
  return Object.freeze(JSON.parse(JSON.stringify(state)));
}

function setFeedback(message){
  if(!feedback)return;
  const text=String(message||'').trim();
  feedback.textContent=text;
  feedback.hidden=!text;
}

function setDockOpen(next){
  const open=!!next;
  state.dockOpen=open;
  root.dataset.cfDockState=open?'open':'closed';
  tab?.setAttribute('aria-expanded',String(open));
  panel?.setAttribute('aria-hidden',String(!open));
  if(!open)setFeedback('');
}

function updateCurrentTheme(){
  state.currentTheme=
    document.documentElement.getAttribute('data-cf-theme')||'';
}

function setTidioStatus(next){
  const normalized=next==='online'
    ?'online'
    :next==='offline'
      ?'offline'
      :null;

  state.tidioStatus=normalized;
  root.dataset.cfTidioState=normalized||'loading';

  if(!tidioStatus||!tidioDescription)return;

  if(normalized==='online'){
    tidioStatus.textContent='AÇIK';
    tidioStatus.dataset.state='online';
    tidioDescription.textContent='Şimdi bağlan · Tidio';
    return;
  }

  if(normalized==='offline'){
    tidioStatus.textContent='OFFLINE MESAJ';
    tidioStatus.dataset.state='offline';
    tidioDescription.textContent='Mesaj bırakabilirsiniz · Tidio';
    return;
  }

  tidioStatus.textContent='';
  tidioStatus.dataset.state='loading';
  tidioDescription.textContent='Canlı destek · Tidio';
}

function suppressTidioLauncher(){
  if(!window.tidioChatApi)return false;
  tidioApi=window.tidioChatApi;
  try{
    tidioApi.hide();
    state.tidioHideApplied=true;
    return true;
  }catch(error){
    state.lastError='TIDIO_HIDE:'+String(error?.message||error);
    return false;
  }
}

function onTidioOpen(){
  state.tidioOpen=true;
  state.tidioPendingOpen=false;
  root.classList.add('cf-live-contact--tidio-open');
  if(tidioOpenFailTimer){
    clearTimeout(tidioOpenFailTimer);
    tidioOpenFailTimer=null;
  }
}

function onTidioClose(){
  state.tidioOpen=false;
  state.tidioPendingOpen=false;
  root.classList.remove('cf-live-contact--tidio-open');
  suppressTidioLauncher();
}

function bindTidioReady(){
  if(!window.tidioChatApi)return false;

  tidioApi=window.tidioChatApi;
  suppressTidioLauncher();

  state.tidioReady=true;
  const status=tidioApi.getStatus?.();
  setTidioStatus(status);

  if(!state.tidioListenersBound){
    state.tidioListenersBound=true;

    tidioApi.on?.('setStatus',setTidioStatus);
    tidioApi.on?.('open',onTidioOpen);
    tidioApi.on?.('close',onTidioClose);
  }

  if(state.tidioPendingOpen){
    openTidio();
  }

  return true;
}

function attachTidio(){
  if(window.tidioChatApi){
    tidioApi=window.tidioChatApi;

    // Official API allows hide() before full ready.
    suppressTidioLauncher();

    try{
      tidioApi.on?.('ready',bindTidioReady);
    }catch(_){}

    if(tidioApi.getStatus?.()){
      bindTidioReady();
    }
  }

  document.addEventListener('tidioChat-ready',bindTidioReady);

  let attempts=0;
  tidioPoll=window.setInterval(()=>{
    attempts+=1;

    if(window.tidioChatApi){
      suppressTidioLauncher();
      if(window.tidioChatApi.getStatus?.()){
        bindTidioReady();
      }
    }

    if(state.tidioReady||attempts>=300){
      window.clearInterval(tidioPoll);
      tidioPoll=null;
    }
  },50);
}

function openTidio(){
  setDockOpen(false);

  if(!window.tidioChatApi||!state.tidioReady){
    state.tidioPendingOpen=true;
    setFeedback('Canlı destek hazırlanıyor. Lütfen bir an bekleyin.');
    return;
  }

  tidioApi=window.tidioChatApi;
  state.tidioPendingOpen=true;
  root.classList.add('cf-live-contact--tidio-open');

  try{
    tidioApi.show();
    tidioApi.open();

    tidioOpenFailTimer=window.setTimeout(()=>{
      if(!state.tidioOpen){
        state.tidioPendingOpen=false;
        root.classList.remove('cf-live-contact--tidio-open');
        suppressTidioLauncher();
      }
    },3000);
  }catch(error){
    state.tidioPendingOpen=false;
    root.classList.remove('cf-live-contact--tidio-open');
    state.lastError='TIDIO_OPEN:'+String(error?.message||error);
    setFeedback('Canlı destek şu anda açılamadı. WhatsApp üzerinden yazabilirsiniz.');
  }
}

const CK_WA_BUTTON_SELECTOR='#chwhatsapp-btn';
const CK_WA_CONTAINER_SELECTOR='#carthike-chat-button-container';
const CK_WA_WRAPPER_SELECTOR='#carthike-chat-wrapper';

function isOurDock(element){
  return !!element?.closest?.('[data-cf-contact-dock]');
}

function suppressExactCKWhatsApp({
  button,
  container,
  wrapper
}={}){
  const actionButton=
    button||
    document.querySelector(CK_WA_BUTTON_SELECTOR);

  if(!(actionButton instanceof HTMLElement))return false;
  if(isOurDock(actionButton))return false;

  const nativeContainer=
    container||
    actionButton.closest(CK_WA_CONTAINER_SELECTOR)||
    document.querySelector(CK_WA_CONTAINER_SELECTOR);

  const nativeWrapper=
    wrapper||
    document.querySelector(CK_WA_WRAPPER_SELECTOR);

  const nativeHost=
    nativeContainer||
    nativeWrapper;

  if(!(nativeHost instanceof HTMLElement))return false;

  whatsappAction={
    mode:'PROGRAMMATIC_CLICK',
    element:actionButton,
    href:null
  };

  whatsappNativeWrapper=nativeHost;

  state.whatsapp.captured=true;
  state.whatsapp.nativeHidden=true;
  state.whatsapp.actionMode='PROGRAMMATIC_CLICK';
  state.whatsapp.href=null;
  state.whatsapp.unsupportedIframeOnly=false;
  state.whatsapp.lastSeenAt=Date.now();
  state.whatsapp.captures+=1;

  const alreadyHidden=
    nativeHost.getAttribute(
      'data-cf-contact-native-whatsapp-hidden'
    )==='true';

  nativeHost.setAttribute(
    'data-cf-contact-native-whatsapp-hidden',
    'true'
  );
  nativeHost.setAttribute('aria-hidden','true');

  if(!alreadyHidden){
    state.whatsapp.suppressions+=1;
  }

  return true;
}

function captureExactCKWhatsApp(){
  const button=
    document.querySelector(CK_WA_BUTTON_SELECTOR);

  if(!(button instanceof HTMLElement)){
    return false;
  }

  const container=
    button.closest(CK_WA_CONTAINER_SELECTOR)||
    document.querySelector(CK_WA_CONTAINER_SELECTOR);

  const wrapper=
    document.querySelector(CK_WA_WRAPPER_SELECTOR);

  return suppressExactCKWhatsApp({
    button,
    container,
    wrapper
  });
}

function addedNodeContainsCKWhatsApp(node){
  if(!(node instanceof Element))return false;

  if(
    node.matches?.(CK_WA_BUTTON_SELECTOR)||
    node.matches?.(CK_WA_CONTAINER_SELECTOR)||
    node.matches?.(CK_WA_WRAPPER_SELECTOR)
  ){
    return true;
  }

  return !!node.querySelector?.(
    [
      CK_WA_BUTTON_SELECTOR,
      CK_WA_CONTAINER_SELECTOR,
      CK_WA_WRAPPER_SELECTOR
    ].join(',')
  );
}

function attachWhatsApp(){
  // One exact O(1) lookup at startup.
  captureExactCKWhatsApp();

  // Low-cost observer:
  // child additions only. No attribute watching, no geometry scan,
  // no deep all-node scan, no timer/polling.
  whatsappObserver=new MutationObserver(mutations=>{
    state.whatsapp.observerCallbacks+=1;

    for(const mutation of mutations){
      for(const node of mutation.addedNodes){
        if(addedNodeContainsCKWhatsApp(node)){
          captureExactCKWhatsApp();
          return;
        }
      }
    }
  });

  const owner=
    document.body||
    document.documentElement;

  whatsappObserver.observe(owner,{
    subtree:true,
    childList:true
  });

  window.addEventListener(
    'load',
    captureExactCKWhatsApp,
    {once:true}
  );

  window.addEventListener(
    'pageshow',
    captureExactCKWhatsApp
  );
}

function refreshWhatsAppAction(){
  if(
    whatsappAction?.element?.isConnected&&
    whatsappNativeWrapper?.isConnected
  ){
    // Re-assert the hide without scanning the page.
    whatsappNativeWrapper.setAttribute(
      'data-cf-contact-native-whatsapp-hidden',
      'true'
    );
    whatsappNativeWrapper.setAttribute(
      'aria-hidden',
      'true'
    );
    state.whatsapp.nativeHidden=true;
    return true;
  }

  whatsappAction=null;
  whatsappNativeWrapper=null;
  state.whatsapp.captured=false;
  state.whatsapp.nativeHidden=false;
  state.whatsapp.actionMode=null;
  state.whatsapp.href=null;

  return captureExactCKWhatsApp();
}

function openWhatsApp(){
  setDockOpen(false);
  setFeedback('');

  if(!refreshWhatsAppAction()){
    setFeedback(
      'WhatsApp bağlantısı hazırlanıyor. Lütfen birkaç saniye sonra tekrar deneyin.'
    );
    return false;
  }

  try{
    if(
      whatsappAction.mode==='PROGRAMMATIC_CLICK'&&
      whatsappAction.element?.isConnected
    ){
      whatsappAction.element.click();
      return true;
    }
  }catch(error){
    state.lastError='WHATSAPP_OPEN:'+String(error?.message||error);
  }

  setFeedback(
    'WhatsApp şu anda açılamadı. Lütfen tekrar deneyin.'
  );
  return false;
}

function visibleNativeWhatsAppCount(){
  const button=
    document.querySelector(CK_WA_BUTTON_SELECTOR);

  if(!(button instanceof Element))return 0;
  if(isOurDock(button))return 0;

  const container=
    button.closest(CK_WA_CONTAINER_SELECTOR)||
    document.querySelector(CK_WA_CONTAINER_SELECTOR);

  const host=
    container||
    document.querySelector(CK_WA_WRAPPER_SELECTOR)||
    button;

  if(!(host instanceof Element))return 0;

  const style=getComputedStyle(host);
  const rect=host.getBoundingClientRect();

  const visible=(
    style.display!=='none'&&
    style.visibility!=='hidden'&&
    Number(style.opacity||1)>0&&
    rect.width>0&&
    rect.height>0
  );

  return visible?1:0;
}

function initUi(){
  setDockOpen(false);
  setTidioStatus(null);

  tab?.addEventListener(
    'click',
    ()=>setDockOpen(!state.dockOpen)
  );

  closeButtons.forEach(button=>{
    button.addEventListener(
      'click',
      ()=>setDockOpen(false)
    );
  });

  document.addEventListener('keydown',event=>{
    if(event.key==='Escape'){
      setDockOpen(false);
    }
  });

  document.addEventListener('pointerdown',event=>{
    if(
      state.dockOpen&&
      !root.contains(event.target)
    ){
      setDockOpen(false);
    }
  });

  tidioButton?.addEventListener('click',openTidio);
  whatsappButton?.addEventListener('click',openWhatsApp);

  new MutationObserver(updateCurrentTheme).observe(
    document.documentElement,
    {
      attributes:true,
      attributeFilter:['data-cf-theme']
    }
  );
}

initUi();
attachTidio();
attachWhatsApp();

state.status='READY';
document.documentElement.setAttribute(
  'data-cf-live-contact-ready',
  '1'
);

window.CANFOTO_LIVE_CONTACT_DOCK=Object.freeze({
  version:VERSION,
  supportedThemes:SUPPORTED_THEMES,
  getState(){
    state.currentTheme=
      document.documentElement.getAttribute('data-cf-theme')||'';
    return snapshot();
  },
  openDock(){
    setDockOpen(true);
    return snapshot();
  },
  closeDock(){
    setDockOpen(false);
    return snapshot();
  },
  openTidio,
  openWhatsApp,
  rescanWhatsApp(){
    captureExactCKWhatsApp();
    return snapshot();
  },
  getWhatsappAdapterInfo(){
    return Object.freeze({
      adapterMode:state.whatsapp.adapterMode,
      buttonSelector:CK_WA_BUTTON_SELECTOR,
      containerSelector:CK_WA_CONTAINER_SELECTOR,
      wrapperSelector:CK_WA_WRAPPER_SELECTOR,
      observerMode:state.whatsapp.observerMode,
      pollingTimers:state.whatsapp.pollingTimers,
      observerCallbacks:state.whatsapp.observerCallbacks,
      captures:state.whatsapp.captures,
      suppressions:state.whatsapp.suppressions
    });
  },
  visibleNativeWhatsAppCount,
  destroy(){
    whatsappObserver?.disconnect();
    if(tidioPoll)clearInterval(tidioPoll);
    document.removeEventListener(
      'tidioChat-ready',
      bindTidioReady
    );
  }
});

window.dispatchEvent(
  new CustomEvent(
    'canfoto:live-contact-ready',
    {detail:{version:VERSION}}
  )
);
})();
